<template>
  <div id="admin-panel">
    <!-- THEME TOGGLE -->
    <!-- <p @click="toggleTheme"
        style="cursor: pointer">Toggle {{ $store.state.user.lightTheme ? 'dark' : 'light' }} theme</p> -->
    <!-- <div class="header">
      <i class="material-icons">apps</i>
      <h3>{{ $store.state.user.langEng ? "Navigation" : "Navigering" }}</h3>
    </div> -->

    <!-- Start -->
    <a href="/" @click.prevent="resetArticles">Start</a>
    <!-- Create Article -->
    <router-link
      v-if="isAdmin"
      to="/create-article"
      :class="{
        'router-link-exact-active router-link-active': routeOnCreateArticle,
      }"
      >{{
        $store.state.user.langEng ? "Create article" : "Skapa artikel"
      }}</router-link
    >
    <!-- Admin Articles -->
    <div>
      <router-link v-if="isAdmin" to="/admin-articles">{{
        $store.state.user.langEng ? "All articles" : "Alla artiklar"
      }}</router-link>
    </div>
    <!-- Admin Courses -->
    <router-link
      v-if="isAdmin"
      to="/admin/courses"
      :class="{'router-link-exact-active router-link-active' : routeOnAdminCourses}"
    >
      {{ $store.state.user.langEng ? "Courses" : "Kurser" }}
    </router-link>
    <!-- Admin Courses -->
    <router-link
      v-if="isAdmin"
      to="/admin/klasses"
      :class="{'router-link-exact-active router-link-active' : routeOnAdminKlasses}"
    >
      {{ $store.state.user.langEng ? "Classes" : "Klasser" }}
    </router-link>
    <!-- Calendar -->
      <!-- v-if="loggedInUser" -->
    <a
      v-if="false"
      @click.prevent="toCalendar"
      href="/calendar"
      :class="{
        'router-link-exact-active router-link-active': routeOnCalendar,
      }"
      >{{ $store.state.user.langEng ? "Calendar" : "Kalender" }}</a
    >
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import LeftPanel from "./LeftPanel";

@Component({
  extends: LeftPanel,
})
export default class NavigationPanel extends Vue {
  updateSlugInterval = null;

  toggleTheme() {
    this.$store.commit('toggleLightTheme');
  }

  resetArticles() {
    this.$store.commit("forceNewSearch");
    this.$route.fullPath !== '/' && this.$router.push('/').catch(() => {})
  }
  
  created() {
    // start favorites/history slug updater
    this.updateSlugInterval = setInterval(() => {
      this.$store.dispatch("updateArticleSlugs");
    }, 60 * 1000);
  }

  toCalendar() {
    if (!this.routeOnCalendar) {
      this.$router.push("/calendar");
    }
  }
  get loggedInUser() {
    return this.$store.state.user.loggedInUser;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get routeOnCalendar() {
    return this.$route.path.includes("/calendar");
  }

  get routeOnCreateArticle() {
    return this.$route.path.includes("/create-article");
  }

  get routeOnAdminCourses() {
    return this.$route.path.includes("/admin/courses");
  }

  get routeOnAdminKlasses() {
    return this.$route.path.includes("/admin/klasses");
  }

  beforeDestroy() {
    clearInterval(this.updateSlugInterval);
  }
}
</script>

<style scoped lang="scss">
#admin-panel {
  .header {
    align-items: center;
    display: flex;
    margin: 1em 0 0.5em;
    h3 {
      font-size: 1.5rem;
    }
  }
}
div:not(.header) {
  display: flex;
  flex-direction: column;
  a {
    font-size: 1.2rem;
  }
  a:not(:hover):not(.router-link-exact-active) {
    color: var(--main-text-color) !important;
  }
}
</style>
